module.exports = __webpack_public_path__ + "img/icon-search@3x.930e0e70.png";